import React from 'react'
import parser from 'html-react-parser'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { backgroundColor } from './ContentCards1.module.css'

export default function ContentCards1({ data }) {
    const { contentCards1ButtonText, contentCards1Text, contentCards1ButtonLink, contentCards1Title, contentCards1Cards, contentCards1BackgroundColor, contentCards1ButtonExternalLink } = data
    return (
        <div className={`center-content-wrap text-center ${contentCards1BackgroundColor === 'white' ? backgroundColor : ''}`}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 center-content-head'>
                        <h2 className='heading-level-2 blue-color'>{contentCards1Title && parser(contentCards1Title)}</h2>
                        <p>
                            <strong>{contentCards1Text && parser(contentCards1Text)}</strong>
                        </p>
                    </div>
                </div>
                <div className='row'>
                    {contentCards1Cards?.map((item, index) => (
                        <div className='col-md-6' key={index}>
                            <div className='center-content-col'>
                                <figure>
                                    <GatsbyImage
                                        image={getImage(item?.contentCards1CardImage?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                                <div className='heading-level-4 black-color'>
                                    {item.contentCards1CardTitle && parser(item.contentCards1CardTitle)}
                                </div>
                                <p>{item.contentCards1CardText && parser(item.contentCards1CardText)}</p>
                                {item.contentCards1CardButtonExternalLink ? (
                                    <a href={item.contentCards1CardButtonExternalLink} className="btn blue-arrow-btn">
                                        {item.contentCards1CardButtonText}
                                    </a>
                                ) : item.contentCards1CardButtonLink ? (
                                    <Link
                                        to={item.contentCards1CardTitle === 'District Partnerships' ? (`${item.contentCards1CardButtonLink.uri}#district-partnerships`) : item.contentCards1CardButtonLink.uri}
                                        className='btn blue-arrow-btn'
                                    >
                                        {item.contentCards1CardButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    ))}

                    <div className='col-md-12 mt-5'>
                        {contentCards1ButtonExternalLink ? (
                            <a href={contentCards1ButtonExternalLink} className="btn blue-btn">
                                {contentCards1ButtonText}
                            </a>
                        ) : contentCards1ButtonLink ? (
                            <Link to={contentCards1ButtonLink.uri} className='btn blue-btn'>
                                {contentCards1ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
